import { ReactElement } from 'react';

import { MonitoringDetailSidecar } from '$features/monitoring/detail/monitoring-detail-sidecar';

export function MonitoringDetailPage(): ReactElement {
  return <MonitoringDetailSidecar />;
}
